import styled from "@emotion/styled";
import { COLORS } from "../../header/header.styled";
import { tablet } from "../../../../media";

export const Panel = styled.section`
    margin-left: 16px;
    margin-right: 16px;
    margin-bottom: 16px;
    padding: 16px;
    border-radius: 12px;
    background: ${COLORS.surface};
    border: 1px solid ${COLORS.border};
    box-shadow: 0 1px 0 ${COLORS.neutralOverlay} inset;

    ${tablet`
        margin-left: 0;
        margin-right: 0;
    `}
`;

export const FormGrid = styled.form`
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-height: 0;
    -webkit-overflow-scrolling: touch;
    scrollbar-gutter: stable;
    font-family:
        Inter,
        system-ui,
        -apple-system,
        Segoe UI,
        Roboto,
        "Helvetica Neue",
        Arial,
        "Noto Sans";

    /* Hide scrollbar (kept, harmless) */
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        display: none;
    }
`;

export const NameRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    ${tablet`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
    `}
`;

export const Field = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const FieldLabel = styled.label`
    font-family:
        Inter,
        system-ui,
        -apple-system,
        Segoe UI,
        Roboto,
        "Helvetica Neue",
        Arial,
        "Noto Sans";
    font-size: 13px;
    color: ${COLORS.textMuted};
`;

export const Input = styled.input`
    width: 100%;
    background: ${COLORS.general};
    color: ${COLORS.textPrimary};
    border: 2px solid ${COLORS.border};
    border-radius: 12px;
    padding: 12px 12px;
    font-weight: 600;
    font-size: 15px;
    line-height: 1.2;
    box-sizing: border-box;
    transition: box-shadow 0.15s ease, border-color 0.15s ease;
    max-height: 44px;

    &::placeholder {
        color: ${COLORS.textPlaceholder};
    }

    &:focus {
        outline: none;
        border-color: ${COLORS.focusRing};
        box-shadow: inset 0 0 0 1px ${COLORS.focusRing};
    }
`;

export const PhotoRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${COLORS.general};
    color: ${COLORS.textPrimary};
    border: 2px solid ${COLORS.border};
    border-radius: 12px;
    padding: 12px 12px;
    box-sizing: border-box;
    transition: box-shadow 0.15s ease, border-color 0.15s ease;
    max-height: 44px;

    &:focus-within {
        outline: none;
        border-color: ${COLORS.focusRing};
        box-shadow: inset 0 0 0 2px ${COLORS.focusRing};
    }
`;

export const PhotoPreview = styled.img`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
`;

export const AvatarCircle = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: ${COLORS.border};
    color: ${COLORS.textPrimary};
    font-weight: 600;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const ChangeLink = styled.span`
    color: ${COLORS.accent};
    font-weight: 500;
    font-size: 13px;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;

    &:focus {
        outline: none;
    }
`;


export const OnboardBtn = styled.button`
    text-align: center;
    font-size: 15px;
    margin-top: 0px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 12px 12px 12px;
    border-radius: 12px;
    border: none;
    background: ${COLORS.accent};
    color: ${COLORS.onPrimary};
    font-weight: 600;
    cursor: pointer;
    font-family:
        Inter,
        system-ui,
        -apple-system,
        Segoe UI,
        Roboto,
        "Helvetica Neue",
        Arial,
        "Noto Sans";

    &:hover {
        background: ${COLORS.btnHover};
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;
